<!--  -->
<template>
  <div class="empty">
    <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/noOrder.png" alt="" />
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.empty {
  padding-top: 150px;
  text-align: center;
  img {
    width: 350px;
  }
  p {
    padding: 20px;
    color: #333;
    font-size: 28px;
    text-align: center;
  }
}
</style>
